import axios from 'axios'

const websiteApiClient = axios.create({
  baseURL: `https://${process.env.GATSBY_WEBSITE_API_URL}/agencies/${process.env.GATSBY_AGENCY_ID}/`,
})

export { websiteApiClient }
